<div [ngClass]="{ active: active }" class="organisation-item-container">
  <div class="org-item-top-container">
    <div class="org-name">{{ item.orgDescription }}</div>
  </div>
  <div class="org-item-bottom-container">
    <div class="label-span flex-1">
      <label>Description</label>
      <span>{{ item.orgCode }}</span>
    </div>
    <div class="label-span flex-2">
      <label>Responsible</label>
      <span>{{ responsible }}</span>
    </div>
  </div>
</div>
